import React, { useEffect, useRef } from 'react'
import * as echarts from 'echarts/core'
import { BarChart, LineChart, PieChart, FunnelChart, ScatterChart } from 'echarts/charts'
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  MarkLineComponent,
} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'

echarts.use([
  BarChart,
  LineChart,
  PieChart,
  FunnelChart,
  ScatterChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  MarkLineComponent,
  CanvasRenderer,
])

export default function Chart({ option, height = 280 }) {
  const holder = useRef(null)
  const chart = useRef(null)

  useEffect(() => {
    if (!holder.current) return undefined
    chart.current = echarts.init(holder.current, null, { renderer: 'canvas' })
    const onResize = () => chart.current && chart.current.resize()
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
      if (chart.current) chart.current.dispose()
      chart.current = null
    }
  }, [])

  useEffect(() => {
    if (chart.current && option) chart.current.setOption(option, true)
  }, [option])

  return <div ref={holder} style={{ width: '100%', height: `${height}px` }} />
}
